// @flow

export function getScorePercent (votes: number, totalVotes: number) {
  if (totalVotes === 0) {
    return 0
  }
  return (votes / totalVotes) * 100
}



// WEBPACK FOOTER //
// ./src/shared/components/Result/components/ResultList/helpers/getScorePercent.js